import React from "react";
import { Common } from "../../utils";

const OfflineMessage = ({ message }) =>
  <div>
    {Common.showErrorMessage(message)}
  </div>;

export default OfflineMessage;
